import { render, staticRenderFns } from "./successLogo.vue?vue&type=template&id=2e5780da&scoped=true&"
var script = {}
import style0 from "./successLogo.vue?vue&type=style&index=0&id=2e5780da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5780da",
  null
  
)

export default component.exports